@if (advertisement) {
  <section class="banner-section">
    <div class="sponsored-label">פרסום</div>
    <div class="banner-grid">
      <a class="banner-item" [href]="advertisement?.[0]?.linkAdv" target="_blank" rel="noopener sponsored">
        @if (!imageLoaded[0]) {
          <div class="adv-spinner">
            <div class="spinner-ring"></div>
          </div>
        }
        <img [src]="advertisement?.[0]?.image" alt="פרסומת" loading="lazy"
          [class.img-visible]="imageLoaded[0]"
          (load)="onImageLoad(0)" (error)="onImageLoad(0)">
          <div class="banner-shine"></div>
        </a>
        <a class="banner-item banner-item--secondary" [href]="advertisement?.[1]?.linkAdv" target="_blank" rel="noopener sponsored">
          @if (!imageLoaded[1]) {
            <div class="adv-spinner">
              <div class="spinner-ring"></div>
            </div>
          }
          <img [src]="advertisement?.[1]?.image" alt="פרסומת" loading="lazy"
            [class.img-visible]="imageLoaded[1]"
            (load)="onImageLoad(1)" (error)="onImageLoad(1)">
            <div class="banner-shine"></div>
          </a>
        </div>
      </section>
    }
